import React from 'react';
import { Box, Typography, Container, List, ListItem, ListItemText } from '@mui/material';
import ParticleBackground from '../components/ParticleBackground';

const Home: React.FC = () => {

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Hero Section with Particle Background */}
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: 0,
          paddingBottom: '56.25%', // 16:9 비율 (9 / 16 * 100%)
          overflow: 'hidden',
        }}
      >
        {/* Inner Box to contain ParticleBackground and Text, filling the 16:9 space */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            textAlign: 'center',
            p: 4,
          }}
        >
          {/* Particle Background */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: -1, // 파티클이 텍스트 뒤에 오도록 설정
            }}
          >
            <ParticleBackground />
          </Box>

          {/* Text Content */}
          <Box sx={{ position: 'relative', zIndex: 1 }}>
            <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold', textShadow: '2px 2px 4px rgba(0,0,0,0.7)', fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4.5rem' } }}>
              Applied Data Science Lab
            </Typography>
            <Typography variant="h5" component="p" sx={{ textShadow: '1px 1px 3px rgba(0,0,0,0.7)' }}>
              Division of Software
            </Typography>
            <Typography variant="h5" component="p" sx={{ textShadow: '1px 1px 3px rgba(0,0,0,0.7)' }}>
              Yonsei University - Mirae Campus
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* About Us Section */}
      <Box sx={{ backgroundColor: '#f0f0f0', py: 4, textAlign: 'center' }}>
        <Container maxWidth="lg">
          <Typography variant="h3" component="h2" sx={{ fontWeight: 'bold' }}>
            About Us
          </Typography>
        </Container>
      </Box>

      {/* Content Area Below About Us */}
      <Container maxWidth="lg" sx={{ pt: 4, pb: 4, px: 4, backgroundColor: 'white', textAlign: 'center' }}>
        {/* 여기에 내용을 작성하세요 */}
        <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
          Our lab focuses on computer science research, particularly in Artificial Intelligence. We are also actively engaged in Bioinformatics research, with a strong emphasis on areas such as AI-based Drug Discovery, AI-based Healthcare, and Network Analysis. Our research team contributes to solving complex real-world problems through innovative research in these fields.
        </Typography>
      </Container>

      {/* News Section */}
      <Box sx={{ backgroundColor: '#f0f0f0', py: 4, textAlign: 'center' }}>
        <Container maxWidth="lg">
          <Typography variant="h3" component="h2" sx={{ fontWeight: 'bold' }}>
            News
          </Typography>
        </Container>
      </Box>

      {/* Content Area Below News */}
      <Container maxWidth="lg" sx={{ pt: 4, pb: 4, px: 4, backgroundColor: 'white' }}>
        <List>
          <ListItem>
            <ListItemText primary={`[2026-01] Our lab published three new papers—one in Computer Methods and Programs in Biomedicine and two in Briefings in Bioinformatics.`} primaryTypographyProps={{ sx: { fontSize: '1.1rem' } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary={`[2026-02] Jae-Woo Chu gets his master's degree. Congratulation!`} primaryTypographyProps={{ sx: { fontSize: '1.1rem' } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary={`[2025-07] Our lab published a new paper "FACT:Feature Aggregation and Convolution with Transformers for predicting drug classification code" on Bioinformatics!`} primaryTypographyProps={{ sx: { fontSize: '1.1rem' } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary={`[2025-03] Our lab published a new paper "Explainable feature-injected diffusion model for medical image translation" on IEEE Access!`} primaryTypographyProps={{ sx: { fontSize: '1.1rem' } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary={`[2025-01] Our lab published a new paper "DRAW+: network-based computational drug repositioning with attention walking and noise filtering" on Health Information Science and Systems!`} primaryTypographyProps={{ sx: { fontSize: '1.1rem' } }} />
          </ListItem>
        </List>
      </Container>

      {/* Contact Section */}
      <Box sx={{ backgroundColor: '#f0f0f0', py: 4, textAlign: 'center' }}>
        <Container maxWidth="lg">
          <Typography variant="h3" component="h2" sx={{ fontWeight: 'bold' }}>
            Contact
          </Typography>
        </Container>
      </Box>

      {/* Content Area Below Contact */}
      <Container maxWidth="lg" sx={{ pt: 4, pb: 4, px: 4, backgroundColor: 'white' }}>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4 }}>
          <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
              Email: youngcho@yonsei.ac.kr<br /><br />
              Phone: +82-33-760-2245<br /><br />
              Address: 강원도 원주시 흥업면 연세대길 1, 창조관 327/328호 데이터융합분석연구실
            </Typography>
          </Box>
          <Box sx={{ flex: 1, width: '100%', height: 300, backgroundColor: '#e0e0e0', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {/* 여기에 네이버 지도 또는 구글 지도 iframe을 삽입하세요 */}
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4489.357490681643!2d127.89836722568076!3d37.28434590320977!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35637710e6e06bef%3A0x1f439f0d30a631d5!2z7Jew7IS464yA7ZWZ6rWQIOuvuOuemOy6oO2NvOyKpCDssL3sobDqtIA!5e0!3m2!1sko!2skr!4v1754360543518!5m2!1sko!2skr"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen={true}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Yonsei University Map"
            ></iframe>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Home;